import log from '/js/common/Logger'
import _ from 'lodash'

const hb_default_options = {
  bidderSettings: {
    standard: {
      bidCpmAdjustment: function(bidCpm, bid) {
        bidCpm = Math.min(40, bidCpm);
        const adUnitCode = _.result(bid, 'adUnitCode', -1);
        let floor = window.rt.client.getFloor(adUnitCode);
        if (_.isNumber(floor) && bidCpm < floor)  {
          log.debug(`pbjs -> bid from ${bid.bidder} is lower than ${floor}, reverting to return 0`)
          return 0;
        }
        return bidCpm;
        //bidCpm * net rev share * discreptancy factor
        //return bidCpm * .85 * DISCREPANCY_FACTOR;
      },
    },
    // emx_digital: {
    //   bidCpmAdjustment: function (bidCpm, bid) {
    //     return bidCpm
    //     //bidCpm * net rev share * discreptancy factor
    //     //return bidCpm * .85 * DISCREPANCY_FACTOR;
    //   }
    // },
  },
  config: {
    //publisherDomain: "https://readtheory.org",
    userSync: {
      filterSettings: {
        iframe: {
          bidders: '*',
          filter: 'include',
        },
        image: {
          bidders: '*',
          filter: 'include'
        }
      },
    },
    //debug: true,
    // debugging: {
    //   enabled: true,
    //   bidders: ['openx'],
    //   bids: [{
    //     cpm: 1.5,
    //   }],
    // },
    priceGranularity: {
      'buckets': [{
        'min': 0,
        'max': 8,
        'increment': 0.01,
        },
        {
          'min': 8,
          'max': 15,
          'increment': 0.05,
        },
        {
          'min': 15,
          'max': 40,
          'increment': 0.2,
        },
      ],
    },

  },
}
export default hb_default_options
